import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';

@Injectable()
export class NewUserService {

    constructor(
        private http: HttpClient
    ) { }

    newUser(user) {
        return this.http.post(environment.serverUrl + '/user', user);
    }
    publishedFormsCount(){
        return this.http.get(environment.serverUrl + '/taskTemplate/publishCount')
    }

    assetsList(){
        return this.http.get(environment.serverUrl + '/assets')
    }
}



// WEBPACK FOOTER //
// ./src/app/new-user/new-user.service.ts